// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__HPs_-","modalForm":"UpgradeEpcsModal_modalForm__3mJFn","modalFooter":"UpgradeEpcsModal_modalFooter__1GmNC"};